/**
 * Project Data - Centralized project list for the portfolio
 * Learning projects and portfolio projects
 */

export const projectsList = [
  {
    id: 7,
    title: "Pantaloons.com",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/Pantaloons.png?raw=true",
    githubUrl: "https://github.com/aniketpandey2912/pantaloons-clone",
    deployedUrl: "https://pantaloons-clone.vercel.app/",
    description:
      "Now shop hassle-free from the comfort of your couch or your office and get your outfits delivered carefully by our delivery agents along with the feature of cash on delivery with our online clothing stores. Visit our online shopping websites now.",
    techs: [
      "React",
      "Chakra-Ui",
      "Typescript",
      "Node",
      "Express",
      "MongoDB",
      "Cloudinary",
    ],
  },
  {
    id: 6,
    title: "Paytmmall.com",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/ApnaMall.png?raw=true",
    githubUrl: "https://github.com/bhav1kmaru/familiar-wilderness-510",
    deployedUrl: "https://apnamall.vercel.app/",
    description:
      "Apna Mall is an e-commerce website that allows users to shop for a wide range of products online. The website offers a wide range of collections of products, including electronics, fashion, home and kitchen appliances, beauty and personal care items, and more.",
    techs: [
      "Next.Js",
      "React",
      "Chakra-Ui",
      "Javascript",
      "Html",
      "CSS",
      "firebase-authentication",
    ],
  },
  {
    id: 4,
    title: "Zee5.com",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/ZeeAppPoster.png?raw=true",
    githubUrl: "https://github.com/rittik24/Zee5.com.clone",
    deployedUrl: "https://comfy-dragon-c64b1f.netlify.app/",
    description:
      "ZEE-5 is a subscription-based streaming service that allows our members to watch TV shows, movies, web series, and News on an internet-connected device. It was a collaborative project and there were 5 members. The duration was 5 days.",
    techs: ["React", "Chakra-Ui", "Javascript", "Html", "Css"],
  },

  {
    id: 3,
    title: "Lately.ai",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/Lately.png?raw=true",
    githubUrl: "https://github.com/aniketpandey2912/acceptable-popcorn-8320",
    deployedUrl: "https://aniketpandey2912-makes-great-sites.netlify.app/",
    description:
      "Lately is an AI-powered content generator and social media management platform that re-purposes long-form text, video, and podcasts. It is an individual project, built and executed in 5 days.",
    techs: ["React", "Chakra-Ui", "Javascript", "Html", "Css"],
  },
  {
    id: 2,
    title: "Cult.fit",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/Cult.png?raw=true",
    githubUrl: "https://github.com/aniketpandey2912/flawless-vegetable-3066",
    deployedUrl: "https://cult-fit-aniket-clone.netlify.app/",
    description:
      "Cult brings Meditation sessions and Goal based workout at your home. It also provides gym equipments. It is an individual project. Built and executed in 5 days.",
    techs: ["React", "Chakra-Ui", "Javascript", "Html", "Css"],
  },
  {
    id: 1,
    title: "Mailtrap",
    imgUrl:
      "https://github.com/aniketpandey2912/aniketpandey2912.github.io/blob/master/src/Sections/Images/Mailtrap.png?raw=true",
    githubUrl: "https://github.com/SubhadeepBid/alleged-partner-6503",
    deployedUrl: "https://super-pithivier-ba36c1.netlify.app/email_api",
    description:
      "Mailtrap is an Email Delivery Platform that allows customers to manage the email infrastructure in one place. It is an individual project. Built and executed in 5 days.",
    techs: ["Javascript", "Html", "Css"],
  },
];

export default projectsList;
